import { ca } from '@cian/analytics';

import { getTrackingProducts } from '../../utils/tracking';

export const trackDocumentClick = (builderId: number, url: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardCountryBuilder',
    action: 'Click_sopr',
    label: 'AnyDocument',
    products: getTrackingProducts(builderId, { document_url: url }),
  });
};
